//#region Angular Imports

import { StateService, StateProvider } from '@uirouter/angularjs'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { default as commonModule, LoggerService } from './../common/common.module'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { UserSession, ConfigHelper } from '../../helpers'

import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { SERVICES_MODULE_NAME } from './../../services'
import { PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SystemService, SYSTEM_SERVICE_NAME, SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListService } from '../../services/system'

import { GroupingLocationCreateEditDirective } from './create-edit/grouping-locations-create-edit.directive'
import { GroupingLocationDetailsDirective } from './details/grouping-locations-details.directive'
import { GroupingLocationController, GroupingLocationScope } from './grouping-locations.controller'

import { GRID_CONTEXT_MENU_SERVICE_NAME, GridContextMenuService } from '../../services/grid'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../services/user-session'
import { GROUPING_LOCATION_SERVICE_NAME, GroupingLocationService } from '../../services/grouping-locations'

import { GroupingLocationHelper } from './grouping-locations.helper'

//#region Asset Imports

import * as TEMPLATE from './grouping-locations.tpl.html'

//#endregion


// Consts

const CONTROLLER_NAME: string = 'GroupingLocationController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'groupingLocationCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'groupingLocationDetails'
const MENU_INDEX = 6
const MODULE_NAME: string = 'simax.grouping-locations'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'GROUPING_LOCATION_NAME'
const STATE_NAME: string = 'groupingLocations'
const STATE_URL: string = '/groupingLocations'

// Consts End


// Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, 'gridster', SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    GRID_CONTEXT_MENU_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    GROUPING_LOCATION_SERVICE_NAME,
    (
        $scope: GroupingLocationScope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        gridContextMenuService: GridContextMenuService,
        userSession: UserSessionService,
        systemService: SystemService,
        groupingLocationService: GroupingLocationService
    ) => new GroupingLocationController(
        $scope,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        gridContextMenuService,
        userSession,
        systemService,
        groupingLocationService,
        GroupingLocationHelper.REFERENCE_TYPE,
        GroupingLocationHelper.SIMAX_MODULE_NAME
    )])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new GroupingLocationDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new GroupingLocationCreateEditDirective()])

module.config(['$stateProvider', 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Grouping_Location_IdLocation',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.GROUPING_LOCATION_LIST)
                && !loggedOperator.hasPermission(Activity.GROUPING_LOCATION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.GroupingLocationModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.GROUP),
                    'groupingLocations',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End


export default MODULE_NAME